import { SimpleEvent } from "./simple-event";

export class BcTimer {
  private _timeOutId?: number;
  private readonly _onTimeoutEvent = new SimpleEvent();
  delay_ms: number;

  get onTimeoutEvent(): SimpleEvent {
    return this._onTimeoutEvent;
  }

  constructor(delay_ms: number = 0) {
    this.delay_ms = delay_ms;
  }

  start(delay_ms?: number): void {
    if (delay_ms != null) {
      this.delay_ms = delay_ms;
    }

    this.stop();
    this._timeOutId = window.setTimeout(() => this._onTimeoutEvent.emit(), this.delay_ms);
  }

  stop(): void {
    window.clearTimeout(this._timeOutId);
  }
}
